
import app from '../../firebase';
import { getFirestore, doc, addDoc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import gcash    from '../../media/gcash.png';
import paymaya  from '../../media/paymaya.png';
import paypal   from '../../media/paypal.png';
import logo     from '../../media/logo.png';


export default function Customer() {

    const { productId } = useParams();

    const [cart, setCart] = useState('Add To Cart');

    // item
    const [quantity, setQuantity] = useState();
    const [coupon, setCoupon] = useState();
    const [variant, setVariant] = useState(null);

    const [profile, setProfile] = useState();
    const [seller, setSeller] = useState();
    const [product, setProduct] = useState();
    const [gallery, setGallery] = useState();

    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });

    const getProduct = () => {
        getDoc(doc(getFirestore(app), `products/${productId}`))
            .then(result => setProduct([result.id, result.data()]));
    }

    const getProfile = () => {
        if (!localStorage.getItem('userId')) return;
        getDoc(doc(getFirestore(app), 'users', localStorage.getItem('userId')))
            .then(result => setProfile([result.id, result.data()]))
    }

    const getSeller = () => {
        getDoc(doc(getFirestore(app), `products/${productId}`))
        .then(result => {
            getDoc(doc(getFirestore(app), `users/${result.data().seller}`))
                .then(result => setSeller([result.id, result.data()]))
        })
    }

    const getGallery = async () => {
        let x = [];
        await getDocs(query(collection(getFirestore(app), 'gallery'), where('product_id', '==', productId)))
            .then(results => results.forEach(i => x.push([i.id, i.data()])));
        setGallery(x);
    }


    const addToCart = () => {
        if (isNaN(quantity) || !quantity || parseInt(quantity) < 1) {
            return alert('Set quantity!');
        }

        let amount = product[1].price * parseInt(quantity);

        // if cart doesn't exist
        if (localStorage.getItem('cart') === null) {

            let cart = [{
                item:       { id: product[0], data: product[1] },
                customer:   { id: profile[0], data: profile[1] },
                seller:     { id: seller[0], data: seller[1] },
                variant,
                quantity,
                amount,
            }];

            if (coupon) {
                cart.coupon = coupon;
                cart.amount = cart.item.price - coupon
            }
            
            localStorage.setItem('cart', JSON.stringify(cart));
        }
        
        // if cart exists
        else {
            let cart = JSON.parse(localStorage.getItem('cart'));

            cart.push({
                item:       { id: product[0], data: product[1] },
                customer:   { id: profile[0], data: profile[1] },
                seller:     { id: seller[0], data: seller[1] },
                variant,
                quantity,
                amount,
            });

            if (coupon) {
                cart.coupon = coupon;
                cart.amount = cart.item.price - coupon
            }
            
            localStorage.setItem('cart', JSON.stringify(cart));
        }

        return alert('Product successfully added to your cart!');
    }

    const createConversation = async () => {
        await addDoc(collection(getFirestore(app), 'conversations'), {

            entity1: {
                id: localStorage.getItem('userId'),
                name: profile[1].name
            },
            
            entity2: {
                id: seller[0],
                name: seller[1].name
            },
            
            date: new Date(),
            messages: []
        });

        window.location.replace('/conversations');
    }

    // check if user have conversation with the seller
    const hasConversation = async () => {
        
        let conversationId = null;
        
        await getDocs(query(collection(getFirestore(app), 'conversations'), where('entity1', '==', localStorage.getItem('userId')), where('entity2', '==', seller[0])))
            .then(results => {
                // if (results.size > 0) {
                    results.forEach(i => conversationId = i.id);
                // }
            });

        await getDocs(collection(getFirestore(app), 'conversations'))

            .then(results => {

                results.forEach(i => {

                    if (i.data().entity1.id === localStorage.getItem('userId') && i.data().entity2.id === seller[0]) {
                        conversationId = i.id;
                    }

                    else if (i.data().entity1.id === seller[0] && i.data().entity2.id === localStorage.getItem('userId')) {
                        conversationId = i.id;
                    }

                })
            });

        if (!conversationId) createConversation();
        else window.location.replace('/conversations');
    }

    useEffect(() => {
        getProduct();
        getGallery();
        getProfile();
        getSeller();

        console.log('WORKING!!!!!')
    }, []);

    return(
        <>
            <div className="container-fluid bg-light p-4">
                <div className="row g-5">
                    <div className="col-lg-6">
                        <div className="h-100 rounded-3 text-center">
                            <img src={product && product[1].image_url} className="d-block mx-auto img-fluid shadow mb-2 w-75" style={{ borderRadius: 20 }} alt={product && product[1].name} />
                            <span className="d-block mt-4 fw-bold">Gallery</span>
                            {
                                gallery && gallery.map(i =>
                                    <img
                                        src={i[1].image_url}
                                        className="img-fluid shadow m-1"
                                        style={{ borderRadius: 20, width: 128, height: 140 }}
                                        alt=""
                                    />
                                )
                            }
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="p-4">

                            {/* product name */}
                            <h4 className="fw-bold">{ product && product[1].name }</h4>
                            
                            {/* price */}
                            <h5 className="text-success">{ formatter.format(product && product[1].price) }</h5>
                            
                            <span className="bg-success text-light rounded-3 fw-bold px-2 py-1">{product && product[1].category}</span>
                            
                            {
                                product && product[1].variants && product[1].variants.length > 0 ?
                                    (
                                        <select className="form-select my-3" onChange={data => setVariant(data.target.value)}>
                                            { product && product[1].variants && product[1].variants.map(i => <option>{ i }</option>) }
                                        </select>
                                    ):<></>
                            }
                            

                            <hr />

                            {/* Product Description */}
                            <p style={{ width: '90%' }}>{ product && product[1].description }</p>

                            {
                                profile ?
                                    <>
                                        <div className="input-group w-50 mb-2">
                                            <input type="number" className="form-control w-50" placeholder="Quantity" onChange={data => setQuantity(data.target.value)} />
                                            <button className="btn btn-dark w-50" onClick={addToCart}><i className="bi-cart me-2"></i>{cart}</button>
                                        </div>

                                        <br />

                                        <img src={gcash}    className="img-fluid shadow rounded-circle m-1" style={{ width: 50 }} alt="homemoto" />
                                        <img src={paymaya}  className="img-fluid shadow rounded-circle m-1" style={{ width: 50 }} alt="homemoto" />
                                        <img src={paypal}   className="img-fluid shadow rounded-circle m-1" style={{ width: 50 }} alt="homemoto" />

                                        {/* store */}
                                        <hr />

                                        <div className="d-flex align-items-center">
                                            <div>
                                                <img src={ seller && seller[1].picture ? seller[1].picture:logo } className="rounded-circle shadow me-3" style={{ width: 80, height: 80 }} alt="" />
                                            </div>
                                            <div>
                                                <span className="d-block fw-bold fs-5">{ seller && seller[1].name }</span>
                                                <button className="btn btn-sm btn-dark" onClick={hasConversation}><i className="bi-chat me-1"></i>Message { seller && seller[1].name }</button>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <button
                                            className="btn btn-lg btn-dark w-100 mb-4 mt-2"
                                            onClick={() => window.location.replace('/login')}
                                        ><i className="bi-lock me-2"></i>Login to purchase</button>
                                    </>
                                }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}